"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Engine = void 0;
var providers_1 = require("./providers");
var AcuraProvider_1 = __importDefault(require("./providers/AcuraProvider"));
var AutoNationProvider_1 = __importDefault(require("./providers/AutoNationProvider"));
var BingProvider_1 = __importDefault(require("./providers/BingProvider"));
var DataDog_1 = __importDefault(require("./providers/DataDog"));
var FacebookPixel_1 = __importDefault(require("./providers/FacebookPixel"));
var FCA_1 = __importDefault(require("./providers/FCA"));
var GA4_1 = __importDefault(require("./providers/GA4"));
var HondaProvider_1 = __importDefault(require("./providers/HondaProvider"));
var HyundaiProvider_1 = __importDefault(require("./providers/HyundaiProvider"));
var NissanProvider_1 = __importDefault(require("./providers/NissanProvider"));
var Engine = /** @class */ (function () {
    function Engine(config, getDealUUID, getVehicle) {
        var _this = this;
        this.providers = config.taggers.map(function (tagger) { return _this.createAnalyticsProviders(tagger, config); });
        this.config = config;
        this.history = {};
        this.getDealUUID = getDealUUID;
        this.getVehicle = getVehicle;
    }
    Engine.prototype.updateProvider = function (tagger) {
        var idx = this.providers.findIndex(function (p) { return p.name === tagger.name; });
        var provider = this.createAnalyticsProviders(tagger, this.config);
        if (idx === -1) {
            this.providers.push(provider);
        }
        else {
            this.providers[idx] = provider;
        }
    };
    /**
     * General Events
     */
    /**
     * Should fire each time OS is opened.
     */
    Engine.prototype.opened = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.opened(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should fire each time OS is closed
     */
    Engine.prototype.closed = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.closed(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should fire the first time a user interacts with OS (when a deal is initially created)
     */
    Engine.prototype.dealCreated = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.dealCreated(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should fire each time a vehicle is added to OS. This event does not fire for the first vehicle that gets added
     * when deal is initially created, as that is handled by dealCreated
     */
    Engine.prototype.vehicleAdded = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.vehicleAdded(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should fire each time a vehicle is removed from OS
     */
    Engine.prototype.vehicleRemoved = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.vehicleRemoved(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Payment Calculator Events
     */
    Engine.prototype.paymentCalcViewed = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.paymentCalcViewed(dealId, _this.getVehicle(vin)); });
    };
    Engine.prototype.paymentCalcInteraction = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.paymentCalcInteraction(dealId, _this.getVehicle(vin)); });
    };
    Engine.prototype.paymentCalcFinished = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.paymentCalcFinished(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Garage Events
     */
    Engine.prototype.garageViewed = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.garageViewed(dealId, _this.getVehicle(vin)); });
    };
    Engine.prototype.garageInteraction = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.garageInteraction(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Test Drive Events
     */
    /**
     * Should be called when the customer first sees the Test Drive form.
     */
    Engine.prototype.testDriveFormViewed = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.testDriveFormViewed(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the customer begins to interact with the Test Drive form/calendar.
     */
    Engine.prototype.testDriveFormStarted = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.testDriveFormStarted(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the customer completes scheduling test drive appointment
     */
    Engine.prototype.testDriveFormFinished = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.testDriveFormFinished(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the customer first sees schedule pickup or delivery form
     */
    Engine.prototype.schedulePickupOrDeliveryFormViewed = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.schedulePickupOrDeliveryFormViewed(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the customer begins to interact with schedule pickup or delivery form
     */
    Engine.prototype.schedulePickupOrDeliveryFormStarted = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) {
            return provider.schedulePickupOrDeliveryFormStarted(dealId, _this.getVehicle(vin));
        });
    };
    /**
     * Should be called when the customer completes schedule pickup or delivery form
     */
    Engine.prototype.schedulePickupOrDeliveryFormFinished = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) {
            return provider.schedulePickupOrDeliveryFormFinished(dealId, _this.getVehicle(vin));
        });
    };
    /**
     * Should be called when the user selects a date in the delivery/pick-up form
     * Always fired before schedulePickupOrDeliveryFormFinished
     */
    Engine.prototype.pickDeliveryDate = function (date) {
        this.providers.forEach(function (provider) { return provider.pickDeliveryDate(date); });
    };
    /**
     * Should be called when the user selects a time of day in the delivery/pick-up form
     * Always fired before schedulePickupOrDeliveryFormFinished
     */
    Engine.prototype.pickDeliveryTime = function (time) {
        this.providers.forEach(function (provider) { return provider.pickDeliveryTime(time); });
    };
    /**
     * Should be fired called when the soft credit form becomes available
     */
    Engine.prototype.softCreditFormViewed = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.softCreditFormViewed(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the customer expresses intent to complete a soft pull credit application
     */
    Engine.prototype.softCreditFormStarted = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.softCreditFormStarted(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the customer successfully completes a Soft credit application
     * and we receive a tracking ID
     */
    Engine.prototype.softCreditFormFinished = function (vin, applicationId) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) {
            return provider.softCreditFormFinished(dealId, _this.getVehicle(vin), applicationId);
        });
    };
    /**
     * TODO Events. Move events above this comment to their respective section as they get refactored for Shift v2
     */
    /**
     * Should be called when a user advances beyond the lead gate on a locked pricing account.
     */
    Engine.prototype.unlockPricing = function () {
        this.providers.forEach(function (provider) { return provider.unlockPricing(); });
    };
    /**
     * Should be called when user views F&I products
     */
    Engine.prototype.menuingViewed = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.menuingViewed(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when menuing F&I product is viewed
     */
    Engine.prototype.ancillaryProductAdded = function (vin, productName) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.ancillaryProductAdded(dealId, _this.getVehicle(vin), productName); });
    };
    /**
     * Should be called when users finished F&I products
     */
    Engine.prototype.menuingFinished = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.menuingFinished(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the user expresses *intent* to value their trade-in.
     * This could be as early as when they answer "yes" to "do you have a trade-in".
     */
    Engine.prototype.tradeInFormViewed = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.tradeInFormViewed(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the user starts typing in the trade in form
     */
    Engine.prototype.tradeInFormStarted = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.tradeInFormStarted(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the customer *accepts* their trade-in value.
     * For us, this means when they choose a "condition" and the value starts being used in loan/lease calculations.
     * @param vin
     * @param programParticipation
     * @return
     */
    Engine.prototype.tradeInFormFinished = function (vin, programParticipation) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) {
            if (programParticipation !== undefined) {
                provider.tradeInFormFinished(dealId, _this.getVehicle(vin), programParticipation);
            }
            else {
                provider.tradeInFormFinished(dealId, _this.getVehicle(vin));
            }
        });
    };
    /**
     * Should be called when a user views the lead form
     * (name, email, phone)
     * @param vin
     * @return
     */
    Engine.prototype.leadFormViewed = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.leadFormViewed(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when a user *begins* to enter data into any "lead" input
     * (name, email, phone)
     * @param vin
     * @return
     */
    Engine.prototype.leadFormStarted = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.leadFormStarted(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when a user has submitted all fields that are required to generate a sales lead.
     * In Online Shopper, this is person.first_name, person.last_name,
     * and at least one of person.email or person.mobile_phone
     * @param vin
     * @return
     */
    Engine.prototype.leadFormFinished = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.leadFormFinished(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the user clicks "Explore Upgrades" in the Continue Deal screen (after grid) in Electric only
     * Right now there's no Skip option here, I'm not sure I'd consider this intent in the same way hardPullCreditAppStart is
     */
    Engine.prototype.upgradesViewed = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.upgradesViewed(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the user adds an accessory to their vehicle
     * @param vin
     * @param id accessory's 'id' property
     * @param addOnName accessory's name
     */
    Engine.prototype.upgradeAdded = function (vin, id, addOnName) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.upgradeAdded(id, dealId, _this.getVehicle(vin), addOnName); });
    };
    /**
     * Should be called when you *leave* the GAP Insurance page in Redline,
     * whether you add it to this vehicle or not.
     * @param vin
     */
    Engine.prototype.upgradesFinished = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.upgradesFinished(dealId, _this.getVehicle(vin)); });
    };
    Engine.prototype.hardCreditFormViewed = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.hardCreditFormViewed(dealId, _this.getVehicle(vin)); });
    };
    Engine.prototype.hardCreditFormStarted = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.hardCreditFormStarted(dealId, _this.getVehicle(vin)); });
    };
    Engine.prototype.hardCreditFormFinished = function (vin, applicationId) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) {
            return provider.hardCreditFormFinished(dealId, _this.getVehicle(vin), applicationId);
        });
    };
    /**
     * Should be called when the customer views the reserve vehicle form.
     */
    Engine.prototype.reserveVehicleFormViewed = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.reserveVehicleFormViewed(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the user begins filling out the reserve vehicle form
     */
    Engine.prototype.reserveVehicleFormStarted = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.reserveVehicleFormStarted(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the user finishes filling out the reserve vehicle form
     */
    Engine.prototype.reserveVehicleFormFinished = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (provider) { return provider.reserveVehicleFormFinished(dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called after a successful sign in to an existing garage,
     * But only if the unlock starts from the Garage flyout
     */
    Engine.prototype.signInToGarageGarageIcon = function () {
        var _this = this;
        this.providers.forEach(function (p) { return p.signInToGarageGarageIcon(_this.getDealUUID()); });
    };
    /**
     * Should be called when the user chooses to Skip the hard credit app.
     */
    Engine.prototype.skipCreditApp = function () {
        this.providers.forEach(function (p) { return p.skipCreditApp(); });
    };
    /**
     * This is called when the user navigates from the first page of Electric's hard Credit App to the second
     * @TODO: ONSHOP-5264 This needs to be replaced with a more flexible, payload-bearing event
     */
    Engine.prototype.creditAppPrimaryPageTwo = function () {
        this.providers.forEach(function (p) { return p.creditAppPrimaryPageTwo(); });
    };
    /**
     * Should be called when the user affirms they have a cosigner in the hard credit app
     */
    Engine.prototype.cosignerYes = function () {
        this.providers.forEach(function (p) { return p.cosignerYes(); });
    };
    /**
     * Should be called when the user chooses one vehicle to Continue Deal (leave the grid) in Electric
     * The backend API will use this to choose the "favorite" vehicle that is sent in ADF
     * @param vin VIN of the vehicle that was chosen to continue
     */
    Engine.prototype.continueDeal = function (vin) {
        var _this = this;
        var dealId = this.getDealUUID();
        this.providers.forEach(function (p) { return p.continueDeal(vin, dealId, _this.getVehicle(vin)); });
    };
    /**
     * Should be called when the interface "feels like" it has rendered a new page of content.
     * In Redline, this fires every time the user Continues to a new Subform
     * @param pagePath
     * @return
     */
    Engine.prototype.virtualPageView = function (pagePath) {
        this.providers.forEach(function (p) { return p.virtualPageView(pagePath); });
    };
    /**
     * Should be called when the user clicks on “Send Garage Key”
     */
    Engine.prototype.signInStart = function () {
        this.providers.forEach(function (p) { return p.signInStart(); });
    };
    /**
     * Should be called when PIN is confirmed
     */
    Engine.prototype.signInComplete = function () {
        var dealId = this.getDealUUID();
        this.providers.forEach(function (p) { return p.signInComplete(dealId); });
    };
    Engine.prototype.createAnalyticsProviders = function (tagger, config) {
        switch (tagger.name) {
            case "sd":
                return new providers_1.ShiftDigitalProvider(config, tagger.payload);
            case "os":
                return new providers_1.OnlineShopperProvider(tagger.name, tagger.payload);
            case "fca":
                return new FCA_1.default(tagger.name, tagger.payload);
            case "hyundai":
                return new HyundaiProvider_1.default(tagger.name, tagger.payload);
            case "ga":
                return new providers_1.GoogleAnalyticsProvider(tagger.name, tagger.payload);
            case "fp":
                return new FacebookPixel_1.default(tagger.name, tagger.payload);
            case "nissan":
                return new NissanProvider_1.default(tagger.name, tagger.payload);
            case "autonation":
                return new AutoNationProvider_1.default(tagger.name, tagger.payload);
            case "bing":
                return new BingProvider_1.default(tagger.name, tagger.payload);
            case "autodata":
                if (tagger.payload.oem === "honda") {
                    return new HondaProvider_1.default(tagger.name, tagger.payload);
                }
                if (tagger.payload.oem === "acura") {
                    return new AcuraProvider_1.default(tagger.name, tagger.payload);
                }
            case "rudder":
                return new providers_1.RudderStack();
            case "ga4":
                return new GA4_1.default(tagger.name, tagger.payload);
            case "datadog":
                return new DataDog_1.default(tagger.name, tagger.payload);
            default:
                return new providers_1.GenericProvider("genericProvider");
        }
    };
    return Engine;
}());
exports.Engine = Engine;
